import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { openModal } from '../../actions/ModalActions';
import discountApi from '../../components/discounts/discountApi';
import CouponFormModal from '../../components/discounts/CouponFormModal';
import PromotionFormModal from '../../components/discounts/PromotionFormModal';
import BulkApplyModal from '../../components/discounts/BulkApplyModal';
import ConfirmModal from '../../components/discounts/ConfirmModal';
import { shortDate, percent, durationLabel, couponTerms, benefitWindow, labelClass } from '../../utils/discountFormat';

/**
 * OPE-112 V2.7: the coupon page is the hub, laid out the way Stripe lays
 * out a coupon — terms and usage up top, details, applicable products,
 * the promotion codes (Candy promotions) that give it away with a "+" to
 * add one without leaving the page, and who currently holds it.
 */
@connect(
    state => ({ canManage: state.auth.user.permissions.includes('MANAGE_DISCOUNTS') }),
    dispatch => bindActionCreators({ openModal }, dispatch)
)
export default class Coupon extends Component {
    constructor(props) {
        super(props);
        this.state = { coupon: null, reference: null, error: null, actionError: null, isActing: false };
    }

    componentDidMount() {
        discountApi.referenceData().then(reference => this.setState({ reference })).catch(error => this.setState({ error: error.message }));
        this.load();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.routeParams.id != this.props.routeParams.id) {
            this.load(nextProps.routeParams.id);
        }
    }

    componentWillUnmount() {
        document.title = 'Fergus CRM';
    }

    load(id = this.props.routeParams.id) {
        discountApi.getCoupon(id)
            .then(coupon => {
                document.title = `${coupon.invoice_name} | Coupons | Fergus CRM`;
                this.setState({ coupon, error: null });
            })
            .catch(error => this.setState({ error: error.message }));
    }

    act(action, id, target) {
        this.setState({ isActing: true, actionError: null });
        var request = target === 'promotion' ? discountApi.promotionAction(id, action) : discountApi.couponAction(id, action);
        request.then(() => { this.setState({ isActing: false }); this.load(); })
            .catch(error => this.setState({ isActing: false, actionError: error.message }));
    }

    confirmArchivePromotion(p) {
        this.props.openModal(ConfirmModal, {
            title: 'Archive promotion code',
            message: `Archive "${p.name}"? It can no longer be applied. Discounts already given to clients are not affected.`,
            confirmText: 'Archive',
            onConfirm: () => this.act('archive', p.promotion_id, 'promotion')
        });
    }

    addPromotion() {
        var { coupon, reference } = this.state;
        this.props.openModal(PromotionFormModal, { reference, couponId: coupon.coupon_id, coupon, stayOnPage: true, onDone: () => this.load() });
    }

    render() {
        var { coupon: c, reference, error, actionError, isActing } = this.state;
        var canManage = this.props.canManage;
        if (error) {
            return <div className="alert alert-danger">{error}</div>;
        }
        if (!c || !reference) {
            return <p className="text-muted">Loading...</p>;
        }
        var productName = (key, type) => {
            if (type === 'user_type') {
                var seat = (reference.user_types || []).find(u => u.key === key);
                return seat ? `${seat.name} (seat type)` : key;
            }
            if (key === reference.sms_product_key) { return 'SMS blocks'; }
            var product = reference.products.find(x => (x.product_ids || []).includes(key));
            return product ? product.name : key;
        };
        var seen = {};
        var products = (c.targets || []).map(t => productName(t.target_key, t.target_type)).filter(n => (seen[n] ? false : (seen[n] = true)));
        var promotions = c.promotions || [];
        var redemptions = c.active_redemptions || [];
        var usage = c.times_redeemed > 0
            ? `${c.times_redeemed} redemption${c.times_redeemed === 1 ? '' : 's'}${c.max_redemptions ? ` of ${c.max_redemptions}` : ''}`
            : 'No redemptions yet';
        var stat = (label, value) => (
            <div className="col-xs-4">
                <div className="text-muted"><small><strong>{label}</strong></small></div>
                <div>{value}</div>
            </div>
        );
        var detail = (label, value) => [
            <dt key={label + '-t'}>{label}</dt>,
            <dd key={label + '-d'}>{value}</dd>
        ];

        return (
            <div className="row page-todo">
                <ol className="breadcrumb page-breadcrumb">
                    <li><Link to="/discounts">Coupons</Link></li>
                    <li className="active">{c.invoice_name}</li>
                </ol>
                <div className="col-md-12">
                    {actionError && <div className="alert alert-danger">{actionError}</div>}

                    <div className="panel panel-default">
                        <div className="panel-heading" style={{ display: 'flex', alignItems: 'center' }}>
                            <h2 style={{ flex: 1, margin: 0 }}>{c.invoice_name} <span className={labelClass(c.state)} style={{ marginLeft: 8, verticalAlign: 'middle' }}>{c.state}</span></h2>
                            {canManage && c.state === 'draft' &&
                                <button type="button" className="btn btn-sm btn-default" style={{ marginRight: 6 }} disabled={isActing}
                                    onClick={() => this.props.openModal(CouponFormModal, { coupon: c, reference, onDone: () => this.load() })}>
                                    <i className="fa fa-pencil"></i> Edit
                                </button>
                            }
                            {canManage && c.state === 'draft' &&
                                <button type="button" className="btn btn-sm btn-success" style={{ marginRight: 6 }} disabled={isActing} onClick={() => this.act('activate', c.coupon_id)}>Activate</button>
                            }
                            {canManage && c.state === 'active' &&
                                <button type="button" className="btn btn-sm btn-info" style={{ marginRight: 6 }} disabled={isActing}
                                    onClick={() => this.props.openModal(BulkApplyModal, { coupon: c, countries: reference.countries, onDone: () => this.load() })}>
                                    Bulk apply&hellip;
                                </button>
                            }
                            {canManage && c.state !== 'archived' && (c.promotion_count || 0) === 0 &&
                                <button type="button" className="btn btn-sm btn-danger" disabled={isActing} onClick={() => this.act('archive', c.coupon_id)}>Archive</button>
                            }
                        </div>
                        <div className="panel-body">
                            <div className="row" style={{ marginBottom: 20 }}>
                                {stat('Type', 'Percentage off')}
                                {stat('Terms', couponTerms(c))}
                                {stat('Usage', usage)}
                            </div>
                            <h4>Details</h4>
                            <div className="row">
                                <div className="col-xs-6">
                                    <dl className="dl-horizontal" style={{ marginBottom: 0 }}>
                                        {detail('ID', <code>{c.slug}</code>)}
                                        {detail('Name', c.invoice_name)}
                                        {detail('Created', shortDate(c.created_at))}
                                    </dl>
                                </div>
                                <div className="col-xs-6">
                                    <dl className="dl-horizontal" style={{ marginBottom: 0 }}>
                                        {detail('Valid', c.state === 'active' ? 'Yes' : (c.state === 'draft' ? 'Not yet (draft)' : 'No (archived)'))}
                                        {detail('Percentage discount', percent(c.percent_off))}
                                        {detail('Duration', durationLabel(c))}
                                        {detail('Redeem by', shortDate(c.redeem_by))}
                                        {detail('Commission impact', <span>{percent(c.commission_impact_ratio)} <small className="text-muted">default; a promotion code can override</small></span>)}
                                    </dl>
                                </div>
                            </div>
                            {c.state === 'draft' && <p className="text-muted" style={{ marginTop: 10, marginBottom: 0 }}><small>Terms can be edited until the coupon is activated; activation freezes them.</small></p>}
                        </div>
                    </div>

                    <div className="panel panel-default">
                        <div className="panel-heading"><h2 style={{ margin: 0 }}><i className="fa fa-cube"></i> Applicable products</h2></div>
                        <div className="panel-body no-padding">
                            {c.scope === 'account' && <p className="text-muted" style={{ padding: 10, marginBottom: 0 }}>All products — every line on the invoice, SMS blocks included.</p>}
                            {c.scope !== 'account' &&
                                <table className="table" style={{ marginBottom: 0 }}>
                                    <thead><tr><th>Name</th></tr></thead>
                                    <tbody>{products.map(n => <tr key={n}><td>{n}</td></tr>)}</tbody>
                                </table>
                            }
                        </div>
                    </div>

                    <div className="panel panel-default">
                        <div className="panel-heading" style={{ display: 'flex', alignItems: 'center' }}>
                            <h2 style={{ flex: 1, margin: 0 }}><i className="fa fa-tag"></i> Promotion codes <small className="text-muted">each one is a campaign that gives these terms away</small></h2>
                            {canManage && c.state !== 'archived' &&
                                <button type="button" className="btn btn-sm btn-info" onClick={this.addPromotion.bind(this)} title="Add a promotion code"><i className="fa fa-plus"></i></button>
                            }
                        </div>
                        <div className="panel-body no-padding">
                            {promotions.length === 0 && <p className="text-muted" style={{ padding: 10, marginBottom: 0 }}>No promotion codes yet. This coupon can still be applied directly or in bulk; add a code with <strong>+</strong> for customers to redeem it themselves.</p>}
                            {promotions.length > 0 &&
                                <table className="table table-hover" style={{ marginBottom: 0 }}>
                                    <thead><tr><th>Promotion code</th><th>Name</th><th>Status</th><th>Countries</th><th className="text-right">Redemptions</th><th>Expires</th><th>Created</th><th></th></tr></thead>
                                    <tbody>
                                        {promotions.map(p =>
                                            <tr key={p.promotion_id} className={p.status === 'archived' ? 'text-muted' : ''}>
                                                <td>{p.code ? <code>{p.code}</code> : <span className="text-muted">no code{p.auto_apply ? ' (auto-apply)' : ''}</span>}</td>
                                                <td><Link to={`/discounts/promotions/${p.promotion_id}`}>{p.name}</Link><div className="text-muted"><small>{p.scheme_type}{p.customer_eligibility !== 'any' ? `, ${p.customer_eligibility} customers` : ''}</small></div></td>
                                                <td><span className={labelClass(p.status)}>{p.status}</span></td>
                                                <td>{(p.countries || []).join(', ') || '–'}</td>
                                                <td className="text-right">{p.redemption_count}</td>
                                                <td>{p.redemption_ends_at ? shortDate(p.redemption_ends_at) : <span className="text-muted">—</span>}</td>
                                                <td>{shortDate(p.created_at)}</td>
                                                <td className="text-right" style={{ whiteSpace: 'nowrap' }}>
                                                    {canManage && (p.status === 'draft' || p.status === 'paused') && c.state === 'active' &&
                                                        <button type="button" className="btn btn-xs btn-success" style={{ marginRight: 4 }} disabled={isActing} onClick={() => this.act('activate', p.promotion_id, 'promotion')}>Activate</button>
                                                    }
                                                    {canManage && p.status === 'active' &&
                                                        <button type="button" className="btn btn-xs btn-warning" style={{ marginRight: 4 }} disabled={isActing} onClick={() => this.act('pause', p.promotion_id, 'promotion')}>Pause</button>
                                                    }
                                                    {canManage && p.status !== 'archived' &&
                                                        <button type="button" className="btn btn-xs btn-danger" disabled={isActing} onClick={() => this.confirmArchivePromotion(p)}>Archive</button>
                                                    }
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                            {c.state === 'draft' && promotions.length > 0 && <p className="text-muted" style={{ padding: 10, marginBottom: 0 }}><small>Activate the coupon before its promotion codes can go live.</small></p>}
                        </div>
                    </div>

                    <div className="panel panel-default">
                        <div className="panel-heading"><h2 style={{ margin: 0 }}><i className="fa fa-users"></i> Active redemptions <small className="text-muted">customers holding this coupon now or scheduled to</small></h2></div>
                        <div className="panel-body no-padding">
                            {redemptions.length === 0 && <p className="text-muted" style={{ padding: 10, marginBottom: 0 }}>No customers found — no customers currently redeem this coupon.</p>}
                            {redemptions.length > 0 &&
                                <table className="table table-condensed" style={{ marginBottom: 0 }}>
                                    <thead><tr><th>Customer</th><th>Via</th><th>Window</th><th>Phase</th></tr></thead>
                                    <tbody>
                                        {redemptions.map(r =>
                                            <tr key={r.client_discount_id}>
                                                <td><Link to={`/clients/${r.client_id}`}>{r.client_name || r.client_id}</Link></td>
                                                <td>{r.promotion_name || <span className="text-muted">coupon applied directly</span>}{r.code && <span> <code>{r.code}</code></span>}</td>
                                                <td>{benefitWindow(r.starts_on, r.ends_on)}</td>
                                                <td><span className={labelClass(r.phase)}>{r.phase}</span></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/pages/discounts/Coupon.js